$(function() {

    function elementScrolled(elem) {
        var inView;

        if ($(elem).offset()) {
            var docViewTop = $(window).scrollTop();
            var docViewBottom = docViewTop + $(window).height();
            var elemTop = $(elem).offset().top + 500;
            inView = (elemTop <= docViewBottom) && (elemTop >= docViewTop);
        } else {
            inView = null;
        }
        
        return inView;
    }

    // Fire graph function if user reloads page while #graph
    // is in the viewport
    // if (elementScrolled('#graph')) {
    //     fireGraph();
    // }

    $(window).on('scroll', function() { 
        // fireGraph();

        // if (elementScrolled('#graph')) {
        //     fireGraph();
        // }
    });

    function fireGraph() {
        // NAS
        $('.nas-front, .nas-back, .nas-base').addClass('toggle');

        // NP
        $('.np-front, .np-back, .np-base').addClass('toggle');

        // MAL
        $('.mal-front, .mal-back, .mal-base').addClass('toggle');

        // CAM
        $('.cam-front, .cam-back, .cam-base').addClass('toggle');

        // MAL -2
        $('.mal-2-front, .mal-2-back, .mal-2-base').addClass('toggle');

        // VLN
        // $('.vln-front, .vln-back, .vln-base').addClass('toggle');

        $('.graph-line').addClass('show-line');
        $('.graph-line.vln-line').addClass('show-vln-line');
    }

});